import React from 'react'
import styles from './JobList.module.css'
import { JobCard } from '../JobCard/JobCard'
import { JobListProps } from '../../types'

export const JobList: React.FC<JobListProps> = ({ jobs, activeTab, onJobClick, config, area = 'nagoya' }) => {
    
    return (
        <div className={styles.jobResultsContainer}>
            {jobs && jobs.length > 0 ? (
                jobs.map((job) => (
                    <JobCard
                        key={job.id}
                        job={job}
                        activeTab={activeTab}
                        onJobClick={onJobClick}
                        config={config}
                        dataClickLabel={job.dataClickLabel}
                        area={area}
                    />
                ))
            ) : (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>求人データを読み込み中...</p>
                </div>
            )}
        </div>
    )
}
